import { Stack } from '@chakra-ui/react'
import { SearchIcon } from 'assets/icons'
import { StyledInput } from 'common/Inputs/SearchInput/styled'

export const SearchInput = ({ width = '100%', height = '100%' }) => (
  <Stack spacing={0} direction="row">
    <StyledInput autocomplete="off" width={width} height={height} />

    <Stack
      position="relative"
      display="flex"
      justifyContent="center"
      cursor="pointer"
      paddingRight="12px"
      alignItems="center"
      borderEndRadius="5px"
      background="white"
    >
      <Stack>
        <SearchIcon />
      </Stack>
    </Stack>
  </Stack>
)
